// enum to apply color classNames
const BACKGROUND = {
  BLACK: 'mui-background-black',
  WHITE: 'mui-background-white',
  PRIMARY: 'mui-background-primary',
  PRIMARY_LIGHT: 'mui-background-primary-light',
  PRIMARY_DARK: 'mui-background-primary-dark',
  PRIMARY_TEXT: 'mui-background-primary-text',
  SECONDARY: 'mui-background-secondary',
  SECONDARY_LIGHT: 'mui-background-secondary-light',
  SECONDARY_DARK: 'mui-background-secondary-dark',
  SECONDARY_TEXT: 'mui-background-secondary-text',
  ERROR: 'mui-background-error',
  ERROR_LIGHT: 'mui-background-error-light',
  ERROR_DARK: 'mui-background-error-dark',
  ERROR_TEXT: 'mui-background-error-text',
  WARNING: 'mui-background-warning',
  WARNING_LIGHT: 'mui-background-warning-light',
  WARNING_DARK: 'mui-background-warning-dark',
  WARNING_TEXT: 'mui-background-warning-text',
  INFO: 'mui-background-info',
  INFO_LIGHT: 'mui-background-info-light',
  INFO_DARK: 'mui-background-info-dark',
  INFO_TEXT: 'mui-background-info-text',
  SUCCESS: 'mui-background-success',
  SUCCESS_LIGHT: 'mui-background-success-light',
  SUCCESS_DARK: 'mui-background-success-dark',
  SUCCESS_TEXT: 'mui-background-success-text',
  GREY_50: 'mui-background-grey-50',
  GREY_100: 'mui-background-grey-100',
  GREY_200: 'mui-background-grey-200',
  GREY_300: 'mui-background-grey-300',
  GREY_400: 'mui-background-grey-400',
  GREY_500: 'mui-background-grey-500',
  GREY_600: 'mui-background-grey-600',
  GREY_700: 'mui-background-grey-700',
  GREY_800: 'mui-background-grey-800',
  GREY_900: 'mui-background-grey-900',
  GREY_A100: 'mui-background-a-100',
  GREY_A200: 'mui-background-a-200',
  GREY_A400: 'mui-background-a-400',
  GREY_A700: 'mui-background-a-700',
  TEXT: 'mui-background-text',
  TEXT_SECONDARY: 'mui-background-text-secondary',
  TEXT_DISABLED: 'mui-background-disabled',
  DIVIDER: 'mui-background-divider',
  PAPER: 'mui-background-paper',
  BACKGROUND: 'mui-background-background',
  ACTION_ACTIVE: 'mui-background-action-active',
  ACTION_HOVER: 'mui-background-action-hover',
  ACTION_SELECTED: 'mui-background-action-selected',
  ACTION_DISABLED: 'mui-background-action-disabled',
  ACTION_DISABLED_BACKGROUND: 'mui-background-action-disabled-background',
  ACTION_FOCUS: 'mui-background-action-focus',

  // Custom colors
  HEADER: 'mui-background-header',
  HEADER_BUTTON: 'mui-background-header-button',
  BOOTH_PACKAGE: 'mui-background-booth-package',
  BOOTH_PACKAGE_LIGHT: 'mui-background-booth-package-light',
  BOOTH_PACKAGE_DARK: 'mui-background-booth-package-dark',
  BOOTH_PACKAGE_TEXT: 'mui-background-booth-package-text',
  POWER_PACKAGE: 'mui-background-power-package',
  POWER_PACKAGE_LIGHT: 'mui-background-power-package-light',
  POWER_PACKAGE_DARK: 'mui-background-power-package-dark',
  POWER_PACKAGE_TEXT: 'mui-background-power-package-text',
};

export default BACKGROUND;
